var collapsibleButtons = document.querySelectorAll('.collapsible__button');

// Function to open the content
function openContent(button) {
  var content = button.nextElementSibling;
  content.style.display = 'block';
  content.style.opacity = 1;
  content.style.visibility = 'visible';
  content.style.height = 'auto';
  button.classList.add('collapsible__button-active');
}

// Function to close the content
function closeContent(button) {
  var content = button.nextElementSibling;
  content.style.display = 'none';
  content.style.opacity = 0;
  content.style.visibility = 'hidden';
  content.style.height = 0;
  button.classList.remove('collapsible__button-active');
}

// Attach event listeners to each button
collapsibleButtons.forEach(function (button) {
  button.addEventListener('click', function () {
    collapsibleButtons.forEach(function (otherButton) {
      if (otherButton !== button) {
        closeContent(otherButton);
      }
    });

    if (button.classList.contains('collapsible__button-active')) {
      closeContent(button);
    } else {
      openContent(button);
    }
  });
});

// Open the first collapsible by default
if (collapsibleButtons.length > 0) {
  openContent(collapsibleButtons[0]);
}
